import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FundRedemptionOfferNormalized } from '../../../../../../../../../store/product/types';

import { FundsListItemDesktop } from './desktop';
import { FundsListItemMobile } from './mobile';
import { FundsListItemTablet } from './tablet';

export namespace FundsListItemTypes {
  export interface Props {
    offer: FundRedemptionOfferNormalized;
  }
}

export const FundsSellListItem: React.FC<FundsListItemTypes.Props> = ({ offer }) => {
  const fundsListItem = useBreakpointValue({
    base: <FundsListItemMobile offer={offer} />,
    sm: <FundsListItemTablet offer={offer} />,
    lg: <FundsListItemDesktop offer={offer} />,
  });

  return fundsListItem;
};
